var map = {
	"./Add_Kodansha.svg": 71284,
	"./Anime_Kodansha.svg": 78012,
	"./Art Book_Kodansha.svg": 53383,
	"./Books_Kodansha.svg": 27699,
	"./Data_Kodansha.svg": 29684,
	"./Deals_Kodansha.svg": 87424,
	"./Direction_Kodansha.svg": 88551,
	"./Direction_No_Border_Kodansha.svg": 75370,
	"./Document_Kodansha.svg": 66400,
	"./Events_Kodansha.svg": 45214,
	"./File_Kodansha.svg": 94812,
	"./Games_Kodansha.svg": 22625,
	"./Giveaway_Kodansha.svg": 22876,
	"./Level_Kodansha.svg": 68522,
	"./Live Action_Kodansha.svg": 30723,
	"./Location_Kodansha.svg": 43304,
	"./Magazine_Kodansha.svg": 42408,
	"./Mail_Kodansha.svg": 32856,
	"./Manga_Kodansha.svg": 22011,
	"./Map_Kodansha.svg": 44737,
	"./Men_Kodansha.svg": 82593,
	"./Music_Kodansha.svg": 67224,
	"./Novel_Kodansha.svg": 63575,
	"./Outdoors_Kodansha.svg": 89090,
	"./Photo_Kodansha.svg": 25995,
	"./Picture Book_Kodansha.svg": 3221,
	"./Pin_Kodansha.svg": 75474,
	"./Quote_Kodansha.svg": 19762,
	"./Reading Room_Kodansha.svg": 64377,
	"./Returns_Kodansha.svg": 29173,
	"./Sales_Kodansha.svg": 20226,
	"./Shipping_Kodansha.svg": 50035,
	"./Sport_Kodansha.svg": 58736,
	"./Stairs_Kodansha.svg": 58452,
	"./Survey_Kodansha.svg": 11412,
	"./Sweepstakes_Kodansha.svg": 25857,
	"./Weather_Kodansha.svg": 67797,
	"./Women_Kodansha.svg": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93202;